import React from "react";
import cx from "classnames";
import { Input } from "reactstrap";
import Button from "../../components/Button/Button";
import { addNew } from "../../services/textsForm";
import styles from "../SpotForm/SpotForm.module.scss";
import hotSpotStyles from "../HotSpotForm/HotSpotForm.module.scss";

const SecondStep = ({ state }) => {
    const {
        timeline,
        setTimeline,
        addFieldObject,
        validationError,
        setValidationError,
        changeMultipleFieldsObject } = state
    const firstTimelines = [...timeline];
    const lastTimeline = firstTimelines.pop();

    return (
        <div>
            <p className={hotSpotStyles.title}>Timelines</p>
            <p className={hotSpotStyles.inspirationText}>{addNew.timelinesTitleText}</p>
            <div className={hotSpotStyles.multiFields}>
                {firstTimelines?.map((timelineItem, index) => (
                    <div className={hotSpotStyles.fieldsBox} key={index}>
                        <div className={hotSpotStyles.linkFormsText}>
                            <div>
                                <p className={hotSpotStyles.fieldLabel}>year-month-day</p>
                                <Input
                                    className={cx(hotSpotStyles.input, hotSpotStyles.dateInput, {
                                        [styles.inputError]: validationError.includes("timeline"),
                                    })}
                                    type="text"
                                    name="timelineFullDate"
                                    placeholder="2021-11-27"
                                    onChange={(e) => {
                                        changeMultipleFieldsObject(
                                            e.target.name,
                                            e.target.value,
                                            index,
                                            setTimeline,
                                            timeline
                                        );
                                        setValidationError(
                                            validationError.filter(
                                                (errorItem) => errorItem !== "timeline"
                                            )
                                        );
                                    }}
                                    value={timelineItem.date}
                                />
                            </div>
                            <div className={hotSpotStyles.textareaContainer}>
                                <p className={hotSpotStyles.fieldLabel}>description</p>
                                <p className={cx(hotSpotStyles.fieldLabelTextTextarea, hotSpotStyles.fieldLabelText)}>{addNew.timelineDescriptionTitleText}</p>
                                <Input
                                    className={cx(styles.textarea, {
                                        [styles.inputError]: validationError.includes("timeline"),
                                    })}
                                    type="textarea"
                                    name="timelineText"
                                    placeholder="Timeline Text"
                                    onChange={(e) => {
                                        changeMultipleFieldsObject(
                                            e.target.name,
                                            e.target.value,
                                            index,
                                            setTimeline,
                                            timeline
                                        );
                                        setValidationError(
                                            validationError.filter(
                                                (errorItem) => errorItem !== "timeline"
                                            )
                                        );
                                    }}
                                    value={timelineItem.text}
                                />
                                <p
                                    className={cx(styles.errorLabel, {
                                        "d-block": validationError.includes("timeline"),
                                    })}
                                >
                                    {("error", "Please, add timeline")}
                                </p>
                            </div>
                        </div>
                    </div>
                ))}

                <div className={cx(hotSpotStyles.multipalFieldsContainer)}>
                    <div className={hotSpotStyles.fieldsBox}>
                        <div className={hotSpotStyles.linkFormsText}>
                            <div>
                                <p className={hotSpotStyles.fieldLabel}>year-month-day</p>
                                <Input
                                    className={cx(hotSpotStyles.input, hotSpotStyles.dateInput, {
                                        [styles.inputError]: validationError.includes("timeline"),
                                    })}
                                    type="text"
                                    name="timelineFullDate"
                                    placeholder="2021-11-27"
                                    onChange={(e) => {
                                        changeMultipleFieldsObject(
                                            e.target.name,
                                            e.target.value,
                                            timeline.length - 1,
                                            setTimeline,
                                            timeline
                                        );
                                        setValidationError(
                                            validationError.filter(
                                                (errorItem) => errorItem !== "timeline"
                                            )
                                        );
                                    }}
                                    value={lastTimeline?.date??""}
                                />
                            </div>
                            <div className={hotSpotStyles.textareaContainer}>
                                <p className={hotSpotStyles.fieldLabel}>description</p>
                                <p className={cx(hotSpotStyles.fieldLabelTextTextarea, hotSpotStyles.fieldLabelText)}>{addNew.timelineDescriptionTitleText}</p>
                                <Input
                                    className={cx(styles.textarea, {
                                        [styles.inputError]: validationError.includes("timeline"),
                                    })}
                                    type="textarea"
                                    name="timelineText"
                                    placeholder="Timeline Text"
                                    onChange={(e) => {
                                        changeMultipleFieldsObject(
                                            e.target.name,
                                            e.target.value,
                                            timeline.length - 1,
                                            setTimeline,
                                            timeline
                                        );
                                        setValidationError(
                                            validationError.filter(
                                                (errorItem) => errorItem !== "timeline"
                                            )
                                        );
                                    }}
                                    value={lastTimeline?.text ?? ""}
                                />
                                <p
                                    className={cx(styles.errorLabel, {
                                        "d-block": validationError.includes("timeline"),
                                    })}
                                >
                                    {("error", "Please, add timeline")}
                                </p>
                            </div>
                        </div>
                    </div>
                    <Button
                        className={hotSpotStyles.plusButton}
                        onClick={() => addFieldObject(setTimeline, timeline)}
                        disabled={!!lastTimeline && !Object.keys(lastTimeline).length}
                    >
                        +
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default SecondStep